module.exports = __webpack_public_path__ + "static/media/clydeEdna96.75baa3f8.png";